import { useEffect } from 'react'

/**
 * Marks the document once React has hydrated so Playwright can gate
 * interactions on it (pre-hydration input is silently lost: conform resets
 * forms on mount, and clicks can land on nodes React is about to replace —
 * a multi-second window under the vite dev server). Must render as a later
 * sibling of the route content — inside the TemplateChrome Suspense boundary
 * for template routes — so its effect only fires after the route tree's mount
 * effects have run. Rendered from App and GeneralErrorBoundary so both
 * success and error documents get marked.
 */
export function HydrationMarker() {
	useEffect(() => {
		document.documentElement.setAttribute('data-hydrated', 'true')
	}, [])
	return null
}
